import ComponentsTable from "./ComponentsTable";

export default ComponentsTable;
